import { render, staticRenderFns } from "./CreateZones.vue?vue&type=template&id=287a7184&scoped=true"
import script from "./CreateZones.vue?vue&type=script&lang=js"
export * from "./CreateZones.vue?vue&type=script&lang=js"
import style0 from "./CreateZones.vue?vue&type=style&index=0&id=287a7184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a7184",
  null
  
)

export default component.exports